import { z } from 'zod';

export const SCHEDULE_TYPE_OPTIONS = ['all', 'instant', 'scheduled'] as const;

export type ScheduleType = (typeof SCHEDULE_TYPE_OPTIONS)[number];

export const DEFAULT_SCHEDULE_TYPE: ScheduleType = 'all';

export const STATUS_OPTIONS = ['all', 'pending', 'processing', 'processed', 'failed'] as const;

export type DispersionStatusFilter = (typeof STATUS_OPTIONS)[number];

export const DEFAULT_STATUS: DispersionStatusFilter = 'all';

/**
 * @function setDateToMidnight
 * @description Function to set the time of a date to midnight (00:00:00.000)
 */
const setDateToMidnight = (date: Date) => {
  const adjustedDate = new Date(date);
  adjustedDate.setHours(0, 0, 0, 0);
  return adjustedDate;
};

const searchBoxMyDispersionsSchema = z
  .object({
    customerId: z.string().optional().nullable(),
    areaId: z.string().optional().nullable(),
    fromDate: z.date().optional(),
    toDate: z.date().optional(),
    scheduleType: z.enum(SCHEDULE_TYPE_OPTIONS).default(DEFAULT_SCHEDULE_TYPE),
    status: z.enum(STATUS_OPTIONS).default(DEFAULT_STATUS),
  })
  .refine(
    ({ fromDate, toDate }) => {
      if (fromDate && toDate) {
        return setDateToMidnight(toDate) >= setDateToMidnight(fromDate);
      }
      return true;
    },
    {
      message: 'COMMON:VALIDATIONS:DATE_VALUE_INVALID',
      path: ['toDate'],
    }
  )
  .refine(
    ({ fromDate }) => {
      if (fromDate) {
        const today = setDateToMidnight(new Date());
        return setDateToMidnight(fromDate) <= today;
      }
      return true;
    },
    {
      message: 'COMMON:VALIDATIONS:DATE_VALUE_INVALID',
      path: ['fromDate'],
    }
  );

export type SearchBoxMyDispersionsSchema = z.infer<typeof searchBoxMyDispersionsSchema>;

export default searchBoxMyDispersionsSchema;
